import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LinkOutlinedSvg from "@ant-design/icons-svg/es/asn/LinkOutlined";
import AntdIcon from "../components/AntdIcon";
var LinkOutlined = function LinkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LinkOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LinkOutlined.displayName = 'LinkOutlined';
}
export default /*#__PURE__*/React.forwardRef(LinkOutlined);